import { Detail, Main, Compare, Bookmarks } from '../containers/'

import { mappedEntryPointRoutes } from 'settings/app/constants'

export const routes = [
  {
    path: `${ mappedEntryPointRoutes.doctors }/:id`,
    label: 'Arzt',
    component: Detail,
  },
  {
    path: `${ mappedEntryPointRoutes.hospitals }/:id`,
    label: 'Krankenhaus',
    component: Detail,
  },
  {
    path: `${ mappedEntryPointRoutes.carehomes }/:id`,
    label: 'Pflegeheim',
    component: Detail,
  },
  {
    path: `${ mappedEntryPointRoutes.careservices }/:id`,
    label: 'Pflegedienst',
    component: Detail,
  },
  {
    path: `${ mappedEntryPointRoutes.dayandnightcare }/:id`,
    label: 'TagesUndNachtpflege',
    component: Detail,
  },
  {
    path: `${ mappedEntryPointRoutes.caresupport }/:id`,
    label: 'UnterstützungImAlltag',
    component: Detail,
  },
  {
    path: `${ mappedEntryPointRoutes.hospiceservices }/:id`,
    label: 'Hospizdienst',
    component: Detail,
  },
  { path: `/vergleich`, label: 'Vergleich', component: Compare },
  { path: `/merkliste`, label: 'Merkliste', component: Bookmarks },
  { path: `/`, label: '', component: Main },
]
